@if (isLoading) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<mat-toolbar class="shuttle-checkin-toolbar">
  <div class="toolbar-left">
    <mat-icon mat-list-icon>directions_bus</mat-icon>
    <h1 class="toolbar-title">Shuttle checkin</h1>
  </div>
  <div class="spacer"></div>
  <div class="toolbar-right">
    <button mat-raised-button color="primary" class="btn-change-bus" (click)="openMyBusDialog()">
      <mat-icon>directions_bus</mat-icon>
      <span class="btn-text">{{'FORM.CHANGE_VEHICLE' | transloco}}</span>
    </button>
    <button mat-mini-fab color="primary" aria-label="Refresh" (click)="refresh()">
      <mat-icon>refresh</mat-icon>
    </button>
    <button mat-mini-fab color="primary" aria-label="Close tabs" (click)="clearTabs()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</mat-toolbar>

<div class="container-fluid my-3">
  <div class="dashboard">
    <mat-card class="widget p-4">
      <div class="d-flex justify-content-start align-items-center pe-1">
        <mat-icon class="me-2">flight_land</mat-icon>
        <mat-card-title class="p-0">
          {{ 'SHUTTLE_CHECKIN.OVERVIEW_FROM' | transloco}} Arlanda
        </mat-card-title>
      </div>
      <div class="stats">
        <span class="stat-item">
          <mat-icon class="icon-bottom">people</mat-icon>
          <span>
            {{ totalArrivalOrders }}
          </span>
        </span>
        <span class="stat-item">
          <mat-icon class="icon-bottom">person</mat-icon>
          <span>
            {{ totalArrivalPassengers }}
          </span>
        </span>
        <span class="stat-item">
          <mat-icon class="icon-bottom" [ngClass]="{'icon-highlight': totalArrivalPickups > 0}">
            emoji_people
          </mat-icon>
          <span>
            {{ totalArrivalPickups }} {{ 'SHUTTLE_CHECKIN.COMPANY' | transloco}}
          </span>
          <span>
            {{totalArrivalPersons }} {{ 'SHUTTLE_CHECKIN.PEOPLE' | transloco}}
          </span>
        </span>
      </div>
    </mat-card>

    <mat-card class="widget p-4">
      <div class="d-flex justify-content-start align-items-center pe-1">
        <mat-icon class="me-2">flight_takeoff</mat-icon>
        <mat-card-title class="p-0">{{ 'SHUTTLE_CHECKIN.OVERVIEW_TO' | transloco}}
          Arlanda</mat-card-title>
      </div>
      <div class="stats">
        <span class="stat-item">
          <mat-icon class="icon-bottom">people</mat-icon>{{totalDepartureOrders}}
        </span>
        <span class="stat-item">
          <mat-icon class="icon-bottom">person</mat-icon>{{totalDeparturePassengers}}
        </span>
        <span class="stat-item">
          <mat-icon class="icon-bottom" [ngClass]="{'icon-highlight': totalDeparturePickupCars > 0}">
            directions_car
          </mat-icon>
          <span>
            {{totalDeparturePickupCars}} {{ 'SHUTTLE_CHECKIN.CARS' | transloco}}
          </span>
          <span>
            {{totalDeparturePickupPeople}} {{'SHUTTLE_CHECKIN.PEOPLE' | transloco}}
          </span>
        </span>
      </div>
    </mat-card>
  </div>
</div>

<div class="container-fluid my-2 tab-container">

  <mat-tab-group dynamicHeight (selectedIndexChange)="selectedTabIndexChange($event)"
    [selectedIndex]="selectedTabIndex">
    <mat-tab label="{{'SHUTTLE_CHECKIN.BUS_DEPARTURES' | transloco}}">

      <mat-expansion-panel hideToggle class="group-card">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>filter_list</mat-icon>&nbsp;&nbsp;Sökfilter
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-form-field appearance="outline">
          <mat-label>Sök</mat-label>
          <input matInput (keyup)="applyFilter($event)"
            placeholder="Sök på ordernummer, namn, telefonnummer, email, datum eller status..." #input>
        </mat-form-field>

        <form [formGroup]="orderShuttleForm">
          <div class="filter-table-container">
            <table>
              <tr>
                <td>
                  <mat-form-field appearance="outline">
                    <mat-label>Shuttledatum från</mat-label>
                    <input matInput formControlName="dateFrom" [matDatepicker]="dateFrom">
                    <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
                    <mat-datepicker #dateFrom></mat-datepicker>
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="outline">
                    <mat-label>Tid från</mat-label>
                    <input matInput type="time" value="{{timeFrom}}" formControlName="timeFrom">
                    <mat-icon matSuffix>schedule</mat-icon>
                  </mat-form-field>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <mat-form-field appearance="outline">
                    <mat-label>Shuttledatum till</mat-label>
                    <input matInput formControlName="dateTo" formControlName="dateTo" [matDatepicker]="dateTo">
                    <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                    <mat-datepicker #dateTo></mat-datepicker>
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="outline">
                    <mat-label>Tid till</mat-label>
                    <input matInput type="time" value="{{timeTo}}" formControlName="timeTo">
                    <mat-icon matSuffix>schedule</mat-icon>
                  </mat-form-field>
                </td>
                <td>&nbsp;
                  <button mat-fab color="primary" aria-label="Refresh" (click)="getShuttleBusses()">
                    <mat-icon>refresh</mat-icon>
                  </button>
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td><mat-checkbox [checked]="showPlanned" (change)="valueChangePlanned($event)">Visa
                    Planerade</mat-checkbox></td>
                <td><mat-checkbox [checked]="showActive" (change)="valueChangeActive($event)">Visa
                    Aktiv</mat-checkbox></td>
                <td><mat-checkbox class="checkbox-margin-right" [checked]="showDeparted"
                    (change)="valueChangeDeparture($event)">Visa Avgång</mat-checkbox></td>
                <td><mat-checkbox class="checkbox-margin-right" [checked]="showArrived"
                    (change)="valueChangeArrival($event)">Visa Ankomst</mat-checkbox></td>
                <td><mat-checkbox class="checkbox-margin-right" [checked]="showCancelled"
                    (change)="valueChangeCancelled($event)">Visa Cancellerade</mat-checkbox></td>
                <td><mat-checkbox [checked]="showNoPassengers" (change)="valueChangeNoPassengers($event)">Visa utan
                    passagerare</mat-checkbox></td>
              </tr>
            </table>
          </div>
        </form>
      </mat-expansion-panel>

      <div class="create-bus-buttons-container">
        <!-- Left Section -->
        <div (click)="createOrderShuttleBus('ARRIVAL');" class="row">
          <h6 class="create-bus-title">{{
            'SHUTTLE_CHECKIN.CREATE_BUS_DEPARTURE_FROM_AIRPORT' |
            transloco}}</h6>
        </div>

        <!-- Right Section -->
        <div (click)="createOrderShuttleBus('DEPARTURE');" class="row">
          <h6 class="create-bus-title">{{
            'SHUTTLE_CHECKIN.CREATE_BUS_DEPARTURE_FROM_PARKING' |
            transloco}}
          </h6>
        </div>
      </div>

      <div class="bus-table-container">
        <table class="bus-departure-table">
          <tr>
            <td class="bus-column-left">
              @for (bus of orderShuttleBussesArr; track bus) {
              <div class="bus-card-wrapper">
                <mat-card appearance="outlined" class="bus-card" (click)="showBusDetails(bus);">
                  <mat-card-title>
                    <div class="bus-card-header">
                      <div class="bus-card-title-left">
                        <mat-icon>flight_land</mat-icon>&nbsp;{{bus.routeName}}
                      </div>
                      <div class="bus-card-title-right">
                        <app-status-badge [text]="bus.status" [isBooking]="true"></app-status-badge>
                      </div>
                    </div>
                  </mat-card-title>
                  <mat-card-content>
                    <div class="bus-card-content">
                      <mat-icon class="icon-bottom" matSuffix>schedule</mat-icon>&nbsp;{{bus.startDate
                      | date: 'yyyy-MM-dd
                      HH:mm'}}&nbsp;|&nbsp;{{bus.driverName}}
                    </div>
                    <table class="bus-info-table">
                      <tr class="bus-info-row">
                        <td><mat-icon class="icon-bottom" mat-list-icon>directions_bus</mat-icon>&nbsp;{{bus.busName}}
                        </td>
                        <td><mat-icon class="icon-bottom">event_seat</mat-icon>&nbsp;{{bus.seats}}
                        </td>
                        <td><mat-icon class="icon-bottom">people</mat-icon>&nbsp;{{bus.passengers}}
                        </td>
                      </tr>
                    </table>
                  </mat-card-content>
                </mat-card>
              </div>
              }
            </td>
            <td class="bus-column-right">
              @for (bus of orderShuttleBussesDep; track bus) {
              <div class="bus-card-wrapper-right">
                <mat-card appearance="outlined" class="bus-card" (click)="showBusDetails(bus);">
                  <mat-card-title>
                    <div class="bus-card-header">
                      <div class="bus-card-title-left">
                        <mat-icon>flight_takeoff</mat-icon>&nbsp;{{bus.routeName}}
                      </div>
                      <div class="bus-card-title-right">
                        <app-status-badge [text]="bus.status" [isBooking]="true"></app-status-badge>
                      </div>
                    </div>
                  </mat-card-title>
                  <mat-card-content>
                    <div class="bus-card-content">
                      <mat-icon class="icon-bottom" matSuffix>schedule</mat-icon>&nbsp;{{bus.startDate
                      | date: 'yyyy-MM-dd
                      HH:mm'}}&nbsp;|&nbsp;{{bus.driverName}}
                    </div>
                    <table class="bus-info-table">
                      <tr class="bus-info-row">
                        <td><mat-icon class="icon-bottom" mat-list-icon>directions_bus</mat-icon>&nbsp;{{bus.busName}}
                        </td>
                        <td><mat-icon class="icon-bottom">event_seat</mat-icon>&nbsp;{{bus.seats}}
                        </td>
                        <td><mat-icon class="icon-bottom">people</mat-icon>&nbsp;{{bus.passengers}}
                        </td>
                      </tr>
                    </table>
                  </mat-card-content>
                </mat-card>
              </div>
              }
            </td>
          </tr>
        </table>
      </div>

    </mat-tab>
    <mat-tab label="{{ 'SHUTTLE_CHECKIN.RESERVATIONS' | transloco }}">
      @if (orderShuttles && orderShuttles.length > 0) {
      <app-back-office24-ordershuttlebus-bookings [orderShuttles]="orderShuttles" [organization]="organization">
      </app-back-office24-ordershuttlebus-bookings>
      }
    </mat-tab>
    @for (tab of tabListValues; track tab) {
    <mat-tab label="{{tab.header}}" class="tab-title">
      <app-back-office24-ordershuttlebus-details
        [organizationId]="$safeNavigationMigration(organization?.organizationId)"
        [orderShuttleBus]="tab.orderShuttleBus"></app-back-office24-ordershuttlebus-details>
    </mat-tab>
    }
  </mat-tab-group>

</div>